/**
 * From angular-ui UI.Layout
 */
import {
  WINDOW_EVT_RESIZE,
  windowEventHelperModule,
} from '../../helpers/window-event-helper/window-event-helper';
import './ui-layout.less';

// broadcast when the layout is being resized (manually or otherwise)
export const UI_LAYOUT_EVT_RESIZE = 'ui.layout.resize';
// broadcast after redrawing during manual resize
export const UI_LAYOUT_EVT_DRAW_COMPLETE = 'ui.layout.draw-complete';

export const UI_LAYOUT_AUTO_SIZE = 'auto';

export const uiLayoutComponentModule = angular
  .module('Q.components.ui-layout', [windowEventHelperModule])
  .controller(
    'uiLayoutCtrl',
    function uiLayoutCtrl(
      $scope,
      $attrs,
      $element,
      $timeout,
      LayoutContainer,
      Layout,
      $log,
    ) {
      const ctrl = this;
      const opts = angular.extend(
        {},
        $scope.$eval($attrs.uiLayout),
        $scope.$eval($attrs.options),
      );
      let numOfSplitbars = 0;
      //var cache = {};
      let animationFrameRequested;
      let lastPos;

      // regex to verify size is properly set to pixels or percent
      const sizePattern = /\d+\s*(px|%)\s*$/i;

      Layout.addLayout(ctrl);

      ctrl.containers = [];
      ctrl.movingSplitbar = null;
      ctrl.bounds = $element[0].getBoundingClientRect();
      ctrl.isUsingColumnFlow = opts.flow === 'column';
      ctrl.sizeProperties = !ctrl.isUsingColumnFlow
        ? {
            sizeProperty: 'height',
            offsetSize: 'offsetHeight',
            offsetPos: 'top',
            flowProperty: 'top',
            oppositeFlowProperty: 'bottom',
            mouseProperty: 'clientY',
            flowPropertyPosition: 'y',
          }
        : {
            sizeProperty: 'width',
            offsetSize: 'offsetWidth',
            offsetPos: 'left',
            flowProperty: 'left',
            oppositeFlowProperty: 'right',
            mouseProperty: 'clientX',
            flowPropertyPosition: 'x',
          };

      $element
        // Force the layout to fill the parent space
        // fix no height layout...
        .addClass('stretch')
        // set the layout css class
        .addClass('ui-layout-' + (opts.flow || 'row'));

      // Initial global size definition
      opts.sizes = opts.sizes || [];
      opts.maxSizes = opts.maxSizes || [];
      opts.minSizes = opts.minSizes || [];
      opts.dividerSize = opts.dividerSize === undefined ? 10 : opts.dividerSize;
      ctrl.opts = opts;

      $scope.updateDisplay = function () {
        ctrl.calculate();
      };

      let debounceEvent;

      function draw() {
        const position = ctrl.sizeProperties.flowProperty;
        const dividerSize = parseInt(opts.dividerSize);
        const elementSize = $element[0][ctrl.sizeProperties.offsetSize];

        if (ctrl.movingSplitbar !== null) {
          const splitbarIndex = ctrl.containers.indexOf(ctrl.movingSplitbar);
          const nextSplitbarIndex =
            splitbarIndex + 2 < ctrl.containers.length
              ? splitbarIndex + 2
              : null;

          if (splitbarIndex > -1) {
            const processedContainers = ctrl.processSplitbar(
              ctrl.containers[splitbarIndex],
            );
            const beforeContainer = processedContainers.beforeContainer;
            const afterContainer = processedContainers.afterContainer;

            // calculate container positons
            const difference = ctrl.movingSplitbar[position] - lastPos;
            let newPosition = ctrl.movingSplitbar[position] - difference;

            // Keep the bar in the window (no left/top 100%)
            newPosition = Math.min(elementSize - dividerSize, newPosition);

            // Keep the bar from going past the previous element min/max values
            if (
              angular.isNumber(beforeContainer.beforeMinValue) &&
              newPosition < beforeContainer.beforeMinValue
            ) {
              newPosition = beforeContainer.beforeMinValue;
            }
            if (
              angular.isNumber(beforeContainer.beforeMaxValue) &&
              newPosition > beforeContainer.beforeMaxValue
            ) {
              newPosition = beforeContainer.beforeMaxValue;
            }

            // Keep the bar from going past the next element min/max values
            if (
              afterContainer !== null &&
              angular.isNumber(afterContainer.afterMinValue) &&
              newPosition > afterContainer.afterMinValue - dividerSize
            ) {
              newPosition = afterContainer.afterMinValue - dividerSize;
            }
            if (
              afterContainer !== null &&
              angular.isNumber(afterContainer.afterMaxValue) &&
              newPosition < afterContainer.afterMaxValue
            ) {
              newPosition = afterContainer.afterMaxValue;
            }

            // resize the before container
            beforeContainer.size = newPosition - beforeContainer[position];
            // store the current value to preserve this size during onResize
            beforeContainer.previousSize = beforeContainer.size;

            // update after container position
            const oldAfterContainerPosition = afterContainer[position];
            afterContainer[position] = newPosition + dividerSize;

            //update after container size if the position has changed
            if (afterContainer[position] !== oldAfterContainerPosition) {
              afterContainer.size =
                nextSplitbarIndex !== null
                  ? oldAfterContainerPosition +
                    afterContainer.size -
                    (newPosition + dividerSize)
                  : elementSize - (newPosition + dividerSize);
              // store the current value to preserve this size during onResize
              afterContainer.previousSize = afterContainer.size;
            }

            // move the splitbar
            ctrl.movingSplitbar[position] = newPosition;

            // broadcast an event that resize happened (debounced to 50ms)
            if (debounceEvent) $timeout.cancel(debounceEvent);
            debounceEvent = $timeout(function () {
              $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'draw');
              $scope.$emit(UI_LAYOUT_EVT_DRAW_COMPLETE);
              debounceEvent = null;
            }, 50);
          }
        }

        //Enable a new animation frame
        animationFrameRequested = null;
      }

      function offset(element) {
        const rawDomNode = element[0];
        const body = document.documentElement || document.body;
        const scrollX = window.pageXOffset || body.scrollLeft;
        const scrollY = window.pageYOffset || body.scrollTop;
        const clientRect = rawDomNode.getBoundingClientRect();
        const x = clientRect.left + scrollX;
        const y = clientRect.top + scrollY;
        return { left: x, top: y };
      }

      /**
       * Returns the current value for an option
       * @param  option   The option to get the value for
       * @return The value of the option. Returns null if there was no option set.
       */
      function optionValue(option) {
        if (
          angular.isNumber(option) ||
          (angular.isString(option) && option.match(sizePattern))
        ) {
          return option;
        } else {
          return null;
        }
      }

      //================================================================================
      // Public Controller Functions
      //================================================================================
      ctrl.mouseDownHandler = function (splitbar) {
        // only trigger when left mouse button is pressed:
        $element.addClass('ui-layout-resizing');
        ctrl.movingSplitbar = splitbar;
        ctrl.processSplitbar(splitbar);
      };
      ctrl.mouseUpHandler = function () {
        $element.removeClass('ui-layout-resizing');
        ctrl.movingSplitbar = null;
      };

      ctrl.mouseMoveHandler = function (mouseEvent) {
        const mousePos =
          mouseEvent[ctrl.sizeProperties.mouseProperty] ||
          (mouseEvent.originalEvent &&
            mouseEvent.originalEvent[ctrl.sizeProperties.mouseProperty]) ||
          (mouseEvent.targetTouches
            ? mouseEvent.targetTouches[0][ctrl.sizeProperties.mouseProperty]
            : 0);

        lastPos = mousePos - offset($element)[ctrl.sizeProperties.offsetPos];

        //Cancel previous rAF call
        if (animationFrameRequested) {
          window.cancelAnimationFrame(animationFrameRequested);
        }

        //TODO: cache layout values

        //Animate the page outside the event
        animationFrameRequested = window.requestAnimationFrame(draw);
      };

      /**
       * Returns the min and max values of the ctrl.containers on each side of the container submitted
       * @param container
       * @returns {*}
       */
      ctrl.processSplitbar = function (container) {
        const index = ctrl.containers.indexOf(container);

        const setValues = function (container) {
          const start = container[ctrl.sizeProperties.flowProperty];
          const end =
            container[ctrl.sizeProperties.flowProperty] + container.size;

          container.beforeMinValue = angular.isNumber(container.minSize)
            ? start + container.minSize
            : start;
          container.beforeMaxValue = angular.isNumber(container.maxSize)
            ? start + container.maxSize
            : null;

          container.afterMinValue = angular.isNumber(container.minSize)
            ? end - container.minSize
            : end;
          container.afterMaxValue = angular.isNumber(container.maxSize)
            ? end - container.maxSize
            : null;
        };

        //verify the container was found in the list
        if (index > -1) {
          const beforeContainer = index > 0 ? ctrl.containers[index - 1] : null;
          const afterContainer =
            index + 1 <= ctrl.containers.length
              ? ctrl.containers[index + 1]
              : null;

          if (beforeContainer !== null) setValues(beforeContainer);
          if (afterContainer !== null) setValues(afterContainer);

          return {
            beforeContainer: beforeContainer,
            afterContainer: afterContainer,
          };
        }

        return null;
      };

      /**
       * Checks if a string has a percent symbol in it.
       * @param num
       * @returns {boolean}
       */
      ctrl.isPercent = function (num) {
        return !!(num && angular.isString(num) && num.indexOf('%') > -1);
      };

      /**
       * Converts a number to pixels from percent.
       * @param size
       * @param parentSize
       * @returns {number}
       */
      ctrl.convertToPixels = function (size, parentSize) {
        return Math.floor(parentSize * (parseInt(size) / 100));
      };

      const isAuto = (i) => opts.sizes[i] === UI_LAYOUT_AUTO_SIZE;

      /**
       * Sets the size for each container initially and on window resize.
       */
      ctrl.calculate = function () {
        const dividerSize = parseInt(opts.dividerSize);
        const elementSize =
          $element[0].getBoundingClientRect()[ctrl.sizeProperties.sizeProperty];
        const originalSize = elementSize - dividerSize * numOfSplitbars;
        const containers = ctrl.containers;
        const containerCount = containers.length;

        if (
          originalSize > 0 &&
          containerCount > 0 &&
          $element.children().length > 0
        ) {
          let availableSize = originalSize;
          let usedSpace = 0;
          let numOfAutoContainers = 0;
          let lastAuto;
          let autoSize;
          const sizes = opts.sizes;
          const minSizes = opts.minSizes;
          const maxSizes = opts.maxSizes;

          // calculate sizing for containers
          for (let i = 0; i < containerCount; i++) {
            if (!LayoutContainer.isSplitbar(containers[i])) {
              const c = containers[i];
              if (!isAuto(i)) {
                sizes[i] = c.isCentral
                  ? UI_LAYOUT_AUTO_SIZE
                  : optionValue(c.previousSize) || UI_LAYOUT_AUTO_SIZE;
              }
              minSizes[i] = optionValue(c.minSize);
              maxSizes[i] = optionValue(c.maxSize);

              if (!isAuto(i)) {
                if (ctrl.isPercent(sizes[i])) {
                  sizes[i] = ctrl.convertToPixels(sizes[i], originalSize);
                } else {
                  sizes[i] = parseInt(sizes[i]);
                }
              }

              if (minSizes[i] !== null) {
                if (ctrl.isPercent(minSizes[i])) {
                  minSizes[i] = ctrl.convertToPixels(minSizes[i], originalSize);
                } else {
                  minSizes[i] = parseInt(minSizes[i]);
                }

                // don't allow the container size to be smaller than the minSize
                if (sizes[i] < minSizes[i]) sizes[i] = minSizes[i];
              }

              if (maxSizes[i] !== null) {
                if (ctrl.isPercent(maxSizes[i])) {
                  maxSizes[i] = ctrl.convertToPixels(maxSizes[i], originalSize);
                } else {
                  maxSizes[i] = parseInt(maxSizes[i]);
                }

                // don't allow the container size to be larger than the maxSize
                if (sizes[i] > maxSizes[i]) sizes[i] = maxSizes[i];
              }

              if (isAuto(i)) {
                numOfAutoContainers++;
              } else {
                availableSize -= sizes[i];
              }
            }
          }

          // calculate initial autoSize
          autoSize =
            numOfAutoContainers > 0
              ? Math.floor(availableSize / numOfAutoContainers)
              : 0;

          // Now scan again to check for any auto container outside it's min/max limits
          for (let i = 0; i < containerCount; i++) {
            if (!LayoutContainer.isSplitbar(containers[i]) && isAuto(i)) {
              const maxSize = maxSizes[i];
              const minSize = minSizes[i];
              if (maxSize && maxSize < autoSize) {
                // adjust available size if the container would be too wide
                availableSize -= maxSize;
                numOfAutoContainers--;
              } else if (minSize && minSize > autoSize) {
                // adjust available size if the container would be too narrow
                // Note: this _could_ leave us with too much content for the space, so it might overflow
                //   this is likely preferable to crushing content
                availableSize -= minSize;
                numOfAutoContainers--;
              } else {
                // track the last truly auto container for the remainder
                lastAuto = i;
              }
            }
          }

          // recalculate autosize in case we converted an autosize container
          autoSize =
            numOfAutoContainers > 0
              ? Math.floor(availableSize / numOfAutoContainers)
              : 0;
          /*
           * When the parent size is odd, rounding down the `autoSize` leaves a remainder.
           * This remainder is added to the last auto-sized container in a layout.
           */
          const remainder = Math.max(
            0,
            availableSize - autoSize * numOfAutoContainers,
          );
          for (let i = 0; i < containerCount; i++) {
            const c = containers[i];
            c[ctrl.sizeProperties.flowProperty] = usedSpace;
            c.maxSize = maxSizes[i];
            c.minSize = minSizes[i];

            if (!LayoutContainer.isSplitbar(c)) {
              let newSize;
              if (isAuto(i)) {
                newSize = Math.min(
                  c.maxSize || Infinity,
                  Math.max(c.minSize || 0, autoSize),
                );
                // add the rounding down remainder to the last auto-sized container in the layout
                if (i === lastAuto) {
                  newSize += remainder;
                }
              } else {
                newSize = sizes[i];
                if (availableSize < 0) {
                  // the first fixed container must lose some width if we have negative space due to min/max
                  newSize = Math.min(
                    c.maxSize || Infinity,
                    Math.max(c.minSize || 0, newSize + availableSize),
                  );
                  availableSize = 0;
                }
              }

              c.size = newSize !== null ? newSize : autoSize;
            } else {
              c.size = dividerSize;
            }

            usedSpace += c.size;
          }
        }

        if (debounceEvent) $timeout.cancel(debounceEvent);
        debounceEvent = $timeout(function () {
          $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'calculate');
          debounceEvent = null;
        }, 50);
      };

      /**
       * Adds a container to the list of layout ctrl.containers.
       * @param container The container to add
       */
      ctrl.addContainer = function (container) {
        const index = ctrl.indexOfElement(container.element);
        if (
          !angular.isDefined(index) ||
          index < 0 ||
          ctrl.containers.length < index
        ) {
          $log.error(
            'Invalid index to add container; i=' + index + ', len=',
            ctrl.containers.length,
          );
          return;
        }

        if (LayoutContainer.isSplitbar(container)) {
          numOfSplitbars++;
        }

        container.index = index;
        ctrl.containers.splice(index, 0, container);

        ctrl.calculate();
      };

      /**
       * Remove a container from the list of layout ctrl.containers.
       * @param  container
       */
      ctrl.removeContainer = function (container) {
        const index = ctrl.containers.indexOf(container);
        if (index >= 0) {
          if (!LayoutContainer.isSplitbar(container)) {
            if (ctrl.containers.length > 2) {
              // Assume there's a sidebar between each container
              // We need to remove this container and the sidebar next to it
              if (index === ctrl.containers.length - 1) {
                // We're removing the last element, the side bar is on the left
                ctrl.containers[index - 1].element.remove();
              } else {
                // The side bar is on the right
                ctrl.containers[index + 1].element.remove();
              }
            }
          } else {
            numOfSplitbars--;
          }

          // Need to re-check the index, as a side bar may have been removed
          const newIndex = ctrl.containers.indexOf(container);
          if (newIndex >= 0) {
            ctrl.containers.splice(newIndex, 1);
            ctrl.opts.maxSizes.splice(newIndex, 1);
            ctrl.opts.minSizes.splice(newIndex, 1);
            ctrl.opts.sizes.splice(newIndex, 1);
          }
          ctrl.calculate();
        } else {
          $log.error('removeContainer for container that did not exist!');
        }
      };

      /**
       * Returns an array of layout ctrl.containers.
       * @returns {Array}
       */
      ctrl.getContainers = function () {
        return ctrl.containers;
      };

      /**
       * Returns the container object of the splitbar that is before the one passed in.
       * @param currentSplitbar
       */
      ctrl.getPreviousSplitbarContainer = function (currentSplitbar) {
        if (LayoutContainer.isSplitbar(currentSplitbar)) {
          const currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
          const previousSplitbarIndex = currentSplitbarIndex - 2;
          if (previousSplitbarIndex >= 0) {
            return ctrl.containers[previousSplitbarIndex];
          }
          return null;
        }
        return null;
      };

      /**
       * Returns the container object of the splitbar that is after the one passed in.
       * @param currentSplitbar
       */
      ctrl.getNextSplitbarContainer = function (currentSplitbar) {
        if (LayoutContainer.isSplitbar(currentSplitbar)) {
          const currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
          const nextSplitbarIndex = currentSplitbarIndex + 2;
          if (
            currentSplitbarIndex > 0 &&
            nextSplitbarIndex < ctrl.containers.length
          ) {
            return ctrl.containers[nextSplitbarIndex];
          }
          return null;
        }
        return null;
      };

      /**
       * Checks whether the container before this one is a split bar
       * @param  {container}  container The container to check
       * @return {Boolean}    true if the element before is a splitbar, false otherwise
       */
      ctrl.hasSplitbarBefore = function (container) {
        const index = ctrl.containers.indexOf(container);
        if (1 <= index) {
          return LayoutContainer.isSplitbar(ctrl.containers[index - 1]);
        }

        return false;
      };

      /**
       * Checks whether the container after this one is a split bar
       * @param  {container}  container The container to check
       * @return {Boolean}    true if the element after is a splitbar, false otherwise
       */
      ctrl.hasSplitbarAfter = function (container) {
        const index = ctrl.containers.indexOf(container);
        if (index < ctrl.containers.length - 1) {
          return LayoutContainer.isSplitbar(ctrl.containers[index + 1]);
        }

        return false;
      };

      /**
       * Checks whether the passed in element is a ui-layout type element.
       * @param  {element}  element The element to check
       * @return {Boolean}          true if the element is a layout element, false otherwise.
       */
      ctrl.isLayoutElement = function (element) {
        return (
          element.hasAttribute('ui-layout-container') ||
          element.hasAttribute('ui-splitbar') ||
          element.nodeName === 'UI-LAYOUT-CONTAINER'
        );
      };

      /**
       * Retrieve the index of an element within it's parents context.
       * @param  {element} element The element to get the index of
       * @return {int}             The index of the element within it's parent
       */
      ctrl.indexOfElement = function (element) {
        const parent = element.parent();
        const children = parent.children();
        let containerIndex = 0;
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (ctrl.isLayoutElement(child)) {
            if (element[0] === children[i]) {
              return containerIndex;
            }
            containerIndex++;
          }
        }
        return -1;
      };

      return ctrl;
    },
  )

  .directive('uiLayout', function ($timeout) {
    return {
      restrict: 'AE',
      controller: 'uiLayoutCtrl',
      require: ['^uiLayout', '?rememberUi'],
      link: function (scope, element, attrs, [uiLayoutCtrl, rememberUiCtrl]) {
        scope.$watch(
          function () {
            return element[0][uiLayoutCtrl.sizeProperties.offsetSize];
          },
          function () {
            uiLayoutCtrl.calculate();
          },
        );

        function onResize() {
          scope.$evalAsync(function () {
            uiLayoutCtrl.calculate();
          });
        }

        scope.$on(WINDOW_EVT_RESIZE, onResize);

        // enable storing sizes to localstorage
        $timeout(() => {
          if (rememberUiCtrl) {
            // attempt to reload the previous setup
            let sizes = rememberUiCtrl.retrieve();
            if (sizes && angular.isArray(sizes)) {
              _writeBackSizes(sizes);
              // force an update
              uiLayoutCtrl.calculate();
            }

            scope.$on(UI_LAYOUT_EVT_RESIZE, function (evt, method) {
              let total =
                element[0].getBoundingClientRect()[
                  uiLayoutCtrl.sizeProperties.sizeProperty
                ];

              let sizes = uiLayoutCtrl.opts.sizes.map(function (s, i) {
                const pctSize = Math.min(
                  100,
                  (100 * (uiLayoutCtrl.containers[i].size + 10)) / total,
                );
                return s !== 'auto' ? pctSize : s;
              });
              if (sizes.length) {
                rememberUiCtrl.store(sizes);

                // when the user makes an adjustment, we replace the current attribute sizes with
                // percentages, so window resizes work
                if (method !== 'calculate') {
                  _writeBackSizes(sizes);
                }
              }
            });
          }
        });

        // Writes the current sizes as percentages back onto the child elements
        function _writeBackSizes(sizes) {
          uiLayoutCtrl.containers.forEach(function (c, i) {
            // ignore splitter bars, auto-sized panes, and completely hidden panes
            if (i % 2 === 0 && sizes[i] !== 'auto' && sizes[i] !== 0) {
              c.element.attr('size', Math.min(100, sizes[i]) + '%');
              c.previousSize = sizes[i] + '%';
            }
          });
        }
      },
    };
  })

  .directive('uiSplitbar', function (LayoutContainer) {
    // Get all the page.
    const htmlElement = angular.element(document.body.parentElement);

    return {
      restrict: 'EAC',
      require: '^uiLayout',
      scope: {},

      link: function (scope, element, attrs, ctrl) {
        element.addClass('stretch');
        element.addClass('ui-splitbar');

        const animationClass = ctrl.isUsingColumnFlow
          ? 'animate-column'
          : 'animate-row';
        element.addClass(animationClass);

        scope.splitbar = LayoutContainer.Splitbar();
        scope.splitbar.element = element;

        element.on('mousedown touchstart', function handleMouseDown(e) {
          if (e.button === 0 || e.type === 'touchstart') {
            // only trigger when left mouse button is pressed:
            e.preventDefault();
            e.stopPropagation();

            ctrl.mouseDownHandler(scope.splitbar);

            htmlElement.on('mousemove touchmove', handleMouseMove);
            return false;
          }
        });

        function handleMouseMove(event) {
          scope.$apply(() => ctrl.mouseMoveHandler(event));
        }

        function handleMouseUp() {
          scope.$apply(ctrl.mouseUpHandler);
          htmlElement.off('mousemove touchmove', handleMouseMove);
        }

        htmlElement.on('mouseup touchend', handleMouseUp);

        scope.$watch('splitbar.size', function (newValue) {
          element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
        });

        scope.$watch(
          'splitbar.' + ctrl.sizeProperties.flowProperty,
          function (newValue) {
            element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
          },
        );

        //Add splitbar to layout container list
        ctrl.addContainer(scope.splitbar);

        element.on('$destroy', function () {
          ctrl.removeContainer(scope.splitbar);
          htmlElement.off('mouseup touchend', handleMouseUp);
          htmlElement.off('mousemove touchmove', handleMouseMove);
          scope.$evalAsync();
        });
      },
    };
  })

  .directive('uiLayoutContainer', function (LayoutContainer, $compile) {
    return {
      restrict: 'AE',
      require: '^uiLayout',
      scope: {
        resizable: '=',
        size: '@',
        minSize: '@',
        maxSize: '@',
      },

      compile: function () {
        return {
          pre: function (scope, element, attrs, ctrl) {
            scope.container = LayoutContainer.Container();
            scope.container.element = element;
            scope.container.id = element.attr('id') || null;
            scope.container.layoutId = ctrl.id;
            scope.container.isCentral = attrs.uiLayoutContainer === 'central';

            if (angular.isDefined(scope.resizable)) {
              scope.container.resizable = scope.resizable;
            }
            scope.container.size = scope.size;
            scope.container.previousSize = scope.size;
            scope.container.minSize = scope.minSize;
            scope.container.maxSize = scope.maxSize;
            ctrl.addContainer(scope.container);

            element.on('$destroy', function () {
              ctrl.removeContainer(scope.container);
              scope.$evalAsync();
            });
          },
          post: function (scope, element, attrs, ctrl) {
            element.addClass('stretch');
            element.addClass('ui-layout-container');

            const animationClass = ctrl.isUsingColumnFlow
              ? 'animate-column'
              : 'animate-row';
            element.addClass(animationClass);

            scope.$watch('container.size', function (newValue) {
              element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
              if (newValue === 0) {
                element.addClass('ui-layout-hidden');
              } else {
                element.removeClass('ui-layout-hidden');
              }
            });

            scope.$watch(
              'container.' + ctrl.sizeProperties.flowProperty,
              function (newValue) {
                element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
              },
            );

            //TODO: add ability to disable auto-adding a splitbar after the container
            const parent = element.parent();
            const children = parent.children();
            const index = ctrl.indexOfElement(element);
            const splitbar = angular.element('<div ui-splitbar></div>');
            if (0 < index && !ctrl.hasSplitbarBefore(scope.container)) {
              angular.element(children[index - 1]).after(splitbar);
              $compile(splitbar)(scope);
            } else if (index < children.length - 1) {
              element.after(splitbar);
              $compile(splitbar)(scope);
            }
          },
        };
      },
    };
  })

  .factory('Layout', function () {
    const layouts = [];

    return {
      addLayout: function (ctrl) {
        ctrl.id = layouts.length;
        layouts.push(ctrl);
      },
    };
  })

  .factory('LayoutContainer', function () {
    function BaseContainer() {
      /**
       * Stores element's id if provided
       * @type {string}
       */
      this.id = null;

      /**
       * Id of the parent layout
       * @type {number}
       */
      this.layoutId = null;

      /**
       * Central container that is always resized
       * @type {boolean}
       */
      this.isCentral = false;

      /**
       * actual size of the container, which is changed on every updateDisplay
       * @type {any}
       */
      this.size = UI_LAYOUT_AUTO_SIZE;

      /**
       * cache for the last uncollapsed size
       * @type {any}
       */
      this.previousSize = null;

      this.maxSize = null;
      this.minSize = null;
      this.resizable = true;
      this.element = null;
    }

    // Splitbar container
    function SplitbarContainer() {
      this.size = 10;
      this.left = 0;
      this.top = 0;
      this.element = null;
    }

    return {
      Container: function (initialSize) {
        return new BaseContainer(initialSize);
      },
      Splitbar: function () {
        return new SplitbarContainer();
      },
      isSplitbar: function (container) {
        return container instanceof SplitbarContainer;
      },
    };
  });
